import { FeedbackRoute } from '@powerupsclub/feedback';
import {
  PaymentsContext,
  PaymentsContextProvider,
  PaymentsV3,
} from '@powerupsclub/payments';
import {
  Authorization,
  TrelloPowerUpContext,
  TrelloPowerUpContextProvider,
} from '@powerupsclub/trello';
import { useContext, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from 'react-router-dom';
import { IframeConnector } from './components/IframeConnector';
import { Modal } from './components/Modal';
import { LoggerErrorBoundary } from '@powerupsclub/logger';

const PaymentWrapper = () => {
  const { trelloIframe } = useContext(TrelloPowerUpContext);
  const history = useHistory();
  const { refetchSubscription } = useContext(PaymentsContext);

  return (
    <PaymentsV3
      onComplete={async () => {
        await refetchSubscription({ waitForStatus: 'active' });
        await trelloIframe.set('board', 'private', 'hasSubscription', true);
        trelloIframe.closeModal();
      }}
      onDismiss={async () => {
        const isGuest =
          !trelloIframe.isMemberSignedIn() ||
          !trelloIframe.memberCanWriteToModel('board');

        history.push(`/modal?isTrial=true${isGuest ? '&guest=true' : ''}`);
      }}
    />
  );
};

const AuthWrapper = () => {
  const { isAuthorized, trelloIframe } = useContext(TrelloPowerUpContext);

  useEffect(() => {
    if (isAuthorized) {
      trelloIframe.closePopup();
    }
  }, [isAuthorized, trelloIframe]);

  return (
    <Authorization
      heading="Gallery View"
      headingStyle={{
        fontSize: '16px',
      }}
      imageSrc="./logo.png"
      imageStyle={{
        maxWidth: '75px',
        maxHeight: '75px',
      }}
    />
  );
};

function App() {
  return (
    <LoggerErrorBoundary powerUpKey="galleryView">
      <Router
        basename={
          process.env.NODE_ENV === 'development' ? undefined : '/gallery-view'
        }
      >
        <Switch>
          <Route exact path="/iframeConnector" component={IframeConnector} />

          <TrelloPowerUpContextProvider
            appKey="7c1c5563efb6aad71cdaa4a8a05abd0d"
            appName="Gallery View"
            powerUpKey="galleryView"
            localization={{
              defaultLocale: 'en',
              supportedLocales: ['en'],
              resourceUrl:
                process.env.NODE_ENV === 'development'
                  ? '/strings/{locale}.json'
                  : '/gallery-view/strings/{locale}.json',
            }}
          >
            <PaymentsContextProvider>
              <Route exact path="/payment">
                <PaymentWrapper />
              </Route>
              <Route exact path="/authorize">
                <AuthWrapper />
              </Route>
              <Route exact path="/modal">
                <Modal />
              </Route>
              <FeedbackRoute />
            </PaymentsContextProvider>
          </TrelloPowerUpContextProvider>
        </Switch>
      </Router>
    </LoggerErrorBoundary>
  );
}

export default App;
